import { SelectHook } from '../../../../reactHookForm/SelectHook';

import * as S from './styled';
import { useQueryFetchPages } from '../../../../../apiQuery/useQueryFetchPages';
import Globals from './../../../../../Globals.json';
import { useAppSelector } from '../../../../../redux/store';
import { InputDefault } from '../../../../data/inputDefault';
import ReactSelect from '../../../../data/reactSelect';

interface IProps {
  name: string | undefined;
  setName: any;
  category: string | undefined;
  setCategory: any;
  openFilter: boolean;
}

export function InputFilter({
  name,
  setName,
  category,
  setCategory,
  openFilter,
}: IProps) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const {
    data: categories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQueryFetchPages<any>(
    ['categories'],
    `${Globals.api.categoriesCompleted}/minified`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  return (
    <S.Wrapper>
      {openFilter && (
        <div className="min-screen">
          <InputDefault
            label="Produto"
            placeholder="Produto"
            type="text"
            state={name}
            setState={setName}
          />

          <ReactSelect
            label="Categoria"
            placeholder="Categoria"
            isClearable
            state={category}
            options={categories?.data?.map((item: any) => ({
              ...item,
              value: item?.id_pdv_category,
              label: item.name,
              store_id: item.store_id,
            }))}
            setState={setCategory}
            isLoading={isLoadingCategories}
          />
        </div>
      )}

      <div className="max-screen">
        <InputDefault
          label="Produto"
          placeholder="Produto"
          type="text"
          state={name}
          setState={setName}
        />

        <ReactSelect
          label="Categoria"
          placeholder="Categoria"
          isClearable
          state={category}
          options={categories?.data?.map((item: any) => ({
            ...item,
            value: item?.id_pdv_category,
            label: item.name,
            store_id: item.store_id,
          }))}
          setState={setCategory}
          isLoading={isLoadingCategories}
        />
      </div>
    </S.Wrapper>
  );
}
